const DAY_LABELS_TR = ["Pazartesi", "Sali", "Carsamba", "Persembe", "Cuma", "Cumartesi", "Pazar"];
const SHORT_LABELS_TR = ["Pzt", "Sal", "Car", "Per", "Cum", "Cmt", "Paz"];
const MONTH_LABELS_TR = [
  "Ocak",
  "Subat",
  "Mart",
  "Nisan",
  "Mayis",
  "Haziran",
  "Temmuz",
  "Agustos",
  "Eylul",
  "Ekim",
  "Kasim",
  "Aralik",
];

export function toIsoDate(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function parseIsoDate(iso: string): Date {
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d);
}

export function startOfWeekMonday(date: Date): Date {
  const result = new Date(date);
  const day = result.getDay();
  const offset = (day + 6) % 7;
  result.setDate(result.getDate() - offset);
  result.setHours(0, 0, 0, 0);
  return result;
}

export function addDays(date: Date, days: number): Date {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

export function addDaysIso(isoYmd: string, days: number): string {
  return toIsoDate(addDays(parseIsoDate(isoYmd), days));
}

export function dayLabel(index: number, short = false): string {
  const labels = short ? SHORT_LABELS_TR : DAY_LABELS_TR;
  return labels[index] || "";
}

export function formatTrDate(iso: string): string {
  const date = parseIsoDate(iso);
  const day = date.getDate();
  const month = MONTH_LABELS_TR[date.getMonth()];
  return `${day} ${month}`;
}

export function formatRangeLabel(startIso: string, endIso: string): string {
  const start = parseIsoDate(startIso);
  const end = parseIsoDate(endIso);
  const startMonth = MONTH_LABELS_TR[start.getMonth()];
  const endMonth = MONTH_LABELS_TR[end.getMonth()];
  if (start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear()) {
    return `${start.getDate()} - ${end.getDate()} ${startMonth} ${end.getFullYear()}`;
  }
  return `${start.getDate()} ${startMonth} - ${end.getDate()} ${endMonth} ${end.getFullYear()}`;
}

/** dd.mm.yyyy (takvim bandi) */
export function formatDailyDateDmY(isoYmd: string): string {
  const d = parseIsoDate(isoYmd);
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${dd}.${mm}.${d.getFullYear()}`;
}

/** Pazartesi=0 ... Pazar=6 */
export function weekdayIndexMonday0(isoYmd: string): number {
  const d = parseIsoDate(isoYmd);
  return (d.getDay() + 6) % 7;
}
